import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AppConfigService {
  private appConfig;

  constructor(private http: HttpClient) { }

  loadAppConfig() {
    return this.http.get('/assets/js/appConfig.json')
      .toPromise()
      .then(data => {
        this.appConfig = data;
      });
  }

  getConfig() {
    return this.appConfig;
  }


  setEnvironmentvariables(){
    environment.apiUrl = this.appConfig?.apiUrl;
    environment.attachmentMaxSize = this.appConfig?.attachmentMaxSize;
    environment.defaultPageSize = this.appConfig?.defaultPageSize;
    environment.appUrl = this.appConfig?.appUri;
    environment.SDIFUrl = this.appConfig?.SDIFUrl;
  }
}

